import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import {AuthHttp} from 'angular2-jwt';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {tokenNotExpired} from 'angular2-jwt';
import {AppSettings} from '../app-settings';
import 'rxjs/add/operator/catch';
import 'rxjs/observable/throw';

@Injectable()
export class MeetingService {

  public token: string;

  headers = new Headers({'Accept': 'application/json'});
  options = new RequestOptions({headers: this.headers});

  constructor(private http: Http, private authHttp: AuthHttp) {
   var currentUser = JSON.parse(localStorage.getItem('currentUser'));
   this.token = currentUser && currentUser.token;
  }

  find(params): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/meeting/find",{
    params : params
   }).map(response => response.json());
  }

  list(params): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/meeting/get",{
    params : params
   }).map(response => response.json());
  }

  tally(params): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/meeting/tally",{
    params : params
   }).map(response => response.json());
  }

  attendance(params): Observable<any> {
   return this.authHttp.get(AppSettings.API_STARTPOINT+"/public/api/v1/meeting/attendance",{
    params : params
   }).map(response => response.json());
  }

  save(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/meeting/save", params, this.options).map(response => response.json());
  }

  saveFromSchedules(params): Observable<any> {
   return this.authHttp.post(AppSettings.API_STARTPOINT+"/public/api/v1/meeting/save-from-schedules", params, this.options).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/meeting.service.ts